// extracted by mini-css-extract-plugin
export default {"emotion-wheel":"EmotionWheel_emotion-wheel__jVhHx","emotion-tooltip":"EmotionWheel_emotion-tooltip__Kfq8j"};